import { render, staticRenderFns } from "./CustomerAutocomplete.vue?vue&type=template&id=6e40fd40&scoped=true&"
import script from "./CustomerAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CustomerAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e40fd40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
